module.exports = __webpack_public_path__ + "72d2de2d1f2355d209b4275def2ebe43.svg";